// Category mapping configuration
// Maps category names/IDs to their icons and display names

export const bannerMapping = {
  // Salon Services
  Utensils: {
    name: "Utensils",
    icon: "/images/Banner/Utensils.svg",
    displayName: "Utensil Cleaning",
  },
  Bathroom: {
    name: "Bathroom",
    icon: "/images/Banner/Bathroom.svg",
    displayName: "Bathroom Cleaning",
  },
  Dusting: {
    name: "Dusting",
    icon: "/images/Banner/Dusting.svg",
    displayName: "Dusting",
  },
  Kitchen: {
    name: "Kitchen",
    icon: "/images/Banner/Kitchen.svg",
    displayName: "Kitchen Cleaning",
  },
  Balcony: {
    name: "Balcony",
    icon: "/images/Banner/MoppingBalcony.svg",
    displayName: "Balcony Cleaning",
  },
  Staircase: {
    name: "Staircase",
    icon: "/images/Banner/Stairs.svg",
    displayName: "Staircase Cleaning",
  },
  Sweeping: {
    name: "Sweeping",
    icon: "/images/Banner/Sweeping.svg",
    displayName: "Sweeping",
  },
  "Sweeping and Mopping": {
    name: "Sweeping and Mopping",
    icon: "/images/Banner/SweepingMopping.svg",
    displayName: "Sweeping and Mopping",
  },
  "Fan Cleaning": {
    name: "Fan Cleaning",
    icon: "/images/Banner/FanCleaning.svg",
    displayName: "Fan Cleaning",
  },
  "Water Tank Cleaning": {
    name: "Water Tank Cleaning",
    icon: "/images/Banner/WatertankCleaning.svg",
    displayName: "Water Tank Cleaning",
  },
  "Kitchen Prep": {
    name: "Kitchen Prep",
    icon: "/images/Banner/KitchenPrep.svg",
    displayName: "Kitchen Prep",
  },
  "Window Cleaning": {
    name: "Window Cleaning",
    icon: "/images/Banner/Window.svg",
    displayName: "Window Cleaning",
  },
  "Fridge Cleaning": {
    name: "Fridge Cleaning",
    icon: "/images/Banner/Fridge.svg",
    displayName: "Fridge Cleaning",
  },
  "Roof Top Cleaning": {
    name: "Roof Top Cleaning",
    icon: "/images/Banner/RoofTop.svg",
    displayName: "Roof Top Cleaning",
  },
};

export const bannerDeepCleaningMapping = {
  "Bathroom Deep Cleaning": {
    name: "Bathroom Deep Cleaning",
    icon: "/images/DeepBanner/BathroomDeepCleaning.svg",
    displayName: "Bathroom Deep Cleaning",
  },
  "Kitchen Deep Cleaning": {
    name: "Kitchen Deep Cleaning",
    icon: "/images/DeepBanner/KitchenDeepCleaning.svg",
    displayName: "Kitchen Deep Cleaning",
  },
  "Bedroom Deep Cleaning": {
    name: "Bedroom Deep Cleaning",
    icon: "/images/DeepBanner/BedroomDeepCleaning.svg",
    displayName: "Bedroom Deep Cleaning",
  },
  "Dinning room Deep Cleaning": {
    name: "Dinning room Deep Cleaning",
    icon: "/images/DeepBanner/DinningRoomDeepCleaning.svg",
    displayName: "Dinning room Deep Cleaning",
  },
  "Living room Deep Cleaning": {
    name: "Living room Deep Cleaning",
    icon: "/images/DeepBanner/Livingroomdeepcleaning.svg",
    displayName: "Living room Deep Cleaning",
  },
  "Almirah Deep Cleaning": {
    name: "Almirah Deep Cleaning",
    icon: "/images/DeepBanner/AlmirahDeepCleaning.svg",
    displayName: "Almirah Deep Cleaning",
  },
  "Cabinets Deep Cleaning": {
    name: "Cabinets Deep Cleaning",
    icon: "/images/DeepBanner/CabinetDeepCleaning.svg",
    displayName: "Cabinets Deep Cleaning",
  },
  "Balcony Deep Cleaning": {
    name: "Balcony Deep Cleaning",
    icon: "/images/DeepBanner/BalconyDeepCleaning.svg",
    displayName: "Balcony Deep Cleaning",
  },
  "Rooftop Deep Cleaning": {
    name: "Rooftop Deep Cleaning",
    icon: "/images/DeepBanner/RooftopDeepCleaning.svg",
    displayName: "Rooftop Deep Cleaning",
  },
  "Front Yard Deep Cleaning": {
    name: "Front Yard Deep Cleaning",
    icon: "/images/DeepBanner/FrontYardDeepCleaning.svg",
    displayName: "Front Yard Deep Cleaning",
  },
  "Backyard Deep Cleaning": {
    name: "Backyard Deep Cleaning",
    icon: "/images/DeepBanner/BackyardDeepCleaning.svg",
    displayName: "Backyard Deep Cleaning",
  },
  "Chimney Deep Cleaning": {
    name: "Chimney Deep Cleaning",
    icon: "/images/DeepBanner/ChimneyDeepCleaning.svg",
    displayName: "Chimney Deep Cleaning",
  },
};

// Helper function to get category info by name
export const getBannerInfo = (bannerName, normalCleaning = true) => {
  // console.log(
  //   "Getting banner info for:",
  //   bannerName,
  //   "Normal cleaning:",
  //   normalCleaning,
  // );
  // console.log(bannerMapping[bannerName]);

  if (normalCleaning) {
    return (
      bannerMapping[bannerName] || {
        name: bannerName,
        icon: "/images/Banner/Kitchenprep.svg", // fallback icon
        displayName: bannerName,
        description: "Service category",
        color: "#6B7280",
      }
    );
  } else {
    return (
      bannerDeepCleaningMapping[bannerName] || {
        name: bannerName,
        icon: "/images/DeepBanner/BedroomDeepCleaning.svg", // fallback icon
        displayName: bannerName,
        description: "Service category",
        color: "#6B7280",
      }
    );
  }
};

// Helper function to get category info by ID (if you have category IDs)
export const getBannerInfoById = (categoryId) => {
  // You can extend this to map IDs to names if needed
  return getBannerInfo(categoryId);
};

// Get all banner names
export const getAllBannerNames = () => {
  return Object.keys(bannerMapping);
};

// Get all category info objects
export const getAllBanners = () => {
  return Object.values(bannerMapping);
};

// Check if a category exists
export const bannerExists = (categoryName) => {
  return categoryName in bannerMapping;
};
